import React from 'react';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

const Services = () => (
  <div className="container mt-1">
    <HelmetProvider>
        <Helmet>
        <title>Hizmetler | Boduroğlu Otomotiv</title>
    <meta
      name="description"
      content="Boduroğlu Otomotiv olarak sunduğumuz hizmetler: Periyodik bakım, motor arıza tespiti, kaporta boya, elektronik sistem onarımı ve daha fazlası."
    />
    <meta
      name="keywords"
      content="oto bakım, motor tamiri, periyodik bakım, kaporta boya, klima servisi, fren sistemi, araç tamiri, dudullu servis, kadosan araç servisi"
    />
    <meta property="og:title" content="Hizmetler | Boduroğlu Otomotiv" />
    <meta
      property="og:description"
      content="Kapsamlı oto bakım ve onarım hizmetlerimiz ile Boduroğlu Otomotiv'de aracınızı güvenle emanet edin."
    />
    <meta property="og:url" content="https://bodurogluoto.com/hizmetler" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://bodurogluoto.com/logo.png" />

        </Helmet>
        </HelmetProvider>
    <h2 className="display-4 mb-4 text-center">Hizmetlerimiz</h2>
    <div className="row">
      {[ 
        { 
          title: "Periyodik Bakım Hizmeti", 
          description: "Aracınızın düzenli bakımı ile motor ömrünü uzatıyor ve performansını artırıyoruz.", 
          image: "/images/periyodikbakim.webp" 
        },
        { 
          title: "Mekanik Sistem Onarımları", 
          description: "Her türlü mekanik arızayı tespit edip profesyonel çözümlerle tamir ediyoruz.", 
          image: "/images/mekanikbakim.webp" 
        },
        { 
          title: "Yağ Değişimi ve Filtre Değişimi", 
          description: "Motorun verimli çalışması için gerekli yağ ve filtre değişimlerini gerçekleştiriyoruz.", 
          image: "/images/oilchange.jpg" 
        },
        { 
          title: "Motor Arıza Teşhisi ve Tamiri", 
          description: "Motor arızalarını hızlıca teşhis ederek güvenli ve etkin çözümler sunuyoruz.", 
          image: "/images/engine.webp" 
        },
        { 
          title: "Profesyonel Klima Servisi", 
          description: "Aracınızın klima sistemini temizleyerek verimli çalışmasını sağlıyoruz.", 
          image: "/images/aircon.jpg" 
        },
        { 
          title: "Elektronik Sistem Arıza Teşhisi", 
          description: "Elektronik sistemlerdeki sorunları gelişmiş cihazlarla tespit ediyoruz.", 
          image: "/images/elektronik.jpeg" 
        },
        { 
          title: "Mekanik Frenleme Sistemlerinin Profesyonel Bakımı ve Onarımı", 
          description: "Fren sistemi arızalarına hızlı ve doğru çözümler sunarak güvenli sürüş sağlar.", 
          image: "/images/frenservis.jpg" 
        },
        { 
          title: "Profesyonel Lamba Testi", 
          description: "Aracınızın ışık sistemlerini kontrol ederek güvenli sürüş için gerekli düzenlemeleri yapıyoruz.", 
          image: "/images/lambatest.jpg" 
        },
        { 
          title: "Kaporta Boya Servisi", 
          description: "Aracınızdaki kaporta sorunlarını gidererek orijinal renk ve parlaklıkta boya işlemi yapıyoruz.", 
          image: "/images/boyaservis.jpg" 
        }
      ].map((service, index) => (
        <div className="col-md-4" key={index}>
          <div className="card mb-3">
            <img src={service.image} alt={service.title} className="card-img-top" style={{ height: '200px', objectFit: 'cover' }} />
            <div className="card-body">
              <h5 className="card-title">{service.title}</h5>
              <p className="card-text">{service.description}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Services;
